import { calendarViews } from '@/lib/scheduler/calendar/calendar';

export const calendarViewLocalStorageKey = 'scheduler_calendar_default_view';

type CalendarViewType =
    | typeof calendarViews.day
    | typeof calendarViews.week
    | typeof calendarViews.month;

const defaultValue: CalendarViewType = calendarViews.week;

export const getCalendarViewLocalStorage = () => {
    return (localStorage.getItem(calendarViewLocalStorageKey) as CalendarViewType) ?? defaultValue;
};

export const setCalendarViewLocalStorage = (calendarView: CalendarViewType) => {
    if (calendarView === defaultValue) {
        localStorage.removeItem(calendarViewLocalStorageKey);
        return;
    }
    localStorage.setItem(calendarViewLocalStorageKey, calendarView);
};
